const EnumManuscriptType = {
  REVIEW: 1,
  ORIGINAL_CONTRIBUTION: 2,
  CASE_REPORTS: 3,
  SOCIETY_NEWS: 7,
  LETTER_TO_EDITOR: 10,
};

export default EnumManuscriptType;
